import { CSColorTheme, CSSpotCampaign } from '@websrc/Typings/ContentStack'
import { themeVars } from 'leds'
import { match } from 'ts-pattern'

// eslint-disable-next-line complexity
export function calcBgAndFontColor(
  color: CSSpotCampaign['background_color'] | CSColorTheme['select_theme']
) {
  return match<
    CSSpotCampaign['background_color'] | CSColorTheme['select_theme'],
    { bgColor: string; bgColorKey: keyof typeof themeVars.color; fontColor: string }
  >(color)
    .with('Bright Bluish Green', () => ({
      bgColor: themeVars.color.brightBluishGreen,
      bgColorKey: 'brightBluishGreen',
      fontColor: themeVars.color.black,
    }))
    .with('Corporate Blue', () => ({
      bgColor: themeVars.color.blue5,
      bgColorKey: 'blue5',
      fontColor: themeVars.color.black,
    }))
    .with('Corporate Green', () => ({
      bgColor: themeVars.color.green,
      bgColorKey: 'green',
      fontColor: themeVars.color.black,
    }))
    .with('Corporate Red', () => ({
      bgColor: themeVars.color.red,
      bgColorKey: 'red',
      fontColor: themeVars.color.black,
    }))
    .with('Corporate Yellow', () => ({
      bgColor: themeVars.color.yellow,
      bgColorKey: 'yellow',
      fontColor: themeVars.color.black,
    }))
    .with('Dark Azur', () => ({
      bgColor: themeVars.color.darkAzur,
      bgColorKey: 'darkAzur',
      fontColor: themeVars.color.black,
    }))
    .with('Flame Yellow Orange', () => ({
      bgColor: themeVars.color.flameYellowOrange,
      bgColorKey: 'flameYellowOrange',
      fontColor: themeVars.color.black,
    }))
    .with('Lime', () => ({
      bgColor: themeVars.color.lime,
      bgColorKey: 'lime',
      fontColor: themeVars.color.black,
    }))
    .with('Medium Azur', () => ({
      bgColor: themeVars.color.mediumAzur,
      bgColorKey: 'mediumAzur',
      fontColor: themeVars.color.black,
    }))
    .with('Orange', () => ({
      bgColor: themeVars.color.orange,
      bgColorKey: 'orange',
      fontColor: themeVars.color.black,
    }))
    .with('White', () => ({
      bgColor: themeVars.color.white,
      bgColorKey: 'white',
      fontColor: themeVars.color.black,
    }))
    .with('Warm Yellow Light', () => ({
      bgColor: themeVars.color.white,
      bgColorKey: 'warmYellowLight',
      fontColor: themeVars.color.black,
    }))
    .with('Coral', () => ({
      bgColor: themeVars.color.white,
      bgColorKey: 'coral',
      fontColor: themeVars.color.black,
    }))
    .with('Coral Light', () => ({
      bgColor: themeVars.color.white,
      bgColorKey: 'coralLight',
      fontColor: themeVars.color.black,
    }))
    .with('Warm Yellow', () => ({
      bgColor: themeVars.color.white,
      bgColorKey: 'warmYellow',
      fontColor: themeVars.color.black,
    }))
    .with('Teal', () => ({
      bgColor: themeVars.color.white,
      bgColorKey: 'teal',
      fontColor: themeVars.color.black,
    }))
    .with('Teal Light', () => ({
      bgColor: themeVars.color.white,
      bgColorKey: 'tealLight',
      fontColor: themeVars.color.black,
    }))
    .with('Azur Light', () => ({
      bgColor: themeVars.color.white,
      bgColorKey: 'azurLight',
      fontColor: themeVars.color.black,
    }))
    .otherwise(() => ({
      bgColor: themeVars.color.grey1,
      bgColorKey: 'grey1',
      fontColor: themeVars.color.black,
    }))
}
